<template>
  <div :class="'about-container ' + (is_en ? 'en' : '')">
    <!-- 公司简介 -->
<!--    <div class="building-image"></div>-->
    <intro-swiper></intro-swiper>
    <section class="intro-section">
      <div class="intro-content">
        <h2>Hewvo Brief</h2>
        <p>Hewvo Enterprise Services Inc. is a digitally-driven global supply chain service partner dedicated to brand customers, with core capabilities spanning production reconfiguration, remanufacturing, and end-to-end after-sales support.
          Hewvo delivers comprehensive closed-loop services across more than 70 countries, including after-sales support, over 5,000 authorized service outlets, and spare parts management for more than 160,000 SKUs</p>
      </div>
    </section>
    <div style="background: #fff;">
      <section class="map">
        <h2>{{ $t("about.part2") }}</h2>
        <img src="@/assets/map/mapp-0630.jpg" alt="">
      </section>
    </div>
    <div style="background: #E9F3FF">
      <!-- 聚焦行业 -->
      <section class="industry-section">
        <h2>{{ $t("about.part3") }}</h2>
        <div class="industry-grid">
          <div v-for="(industry, index) in industries" :key="index" :class="'industry-card-wrapper strong-img carditem'+index">
            <div :class="'industry-card item'+ industry.products.length">
              <div class="circle"></div>
              <h3>{{ $t(`about.industries.${industry.key}`) }}</h3>
              <div>
                <div v-for="(productKey, index) in industry.products" class="industry-item">
                  <p :key="productKey">{{ $t(`about.products.${productKey}`)  }}</p>
                  <img :src="industry.imgs[index]" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div style="background: #fff">
      <section class="partner">
        <h2>{{ $t("about.part4") }}</h2>
        <el-tabs v-model="activeName">
          <el-tab-pane label="ALL" name="all"></el-tab-pane>
          <el-tab-pane v-for="item in partnerList" :label="item.title" :name="item.title"></el-tab-pane>
        </el-tabs>
        <AboutSwiper v-if="activeName == 'all'"></AboutSwiper>
        <AboutSwiper3c v-else-if="activeName == '3C industry'"></AboutSwiper3c>
        <AboutSwiperIt v-else-if="activeName == 'IT industry'"></AboutSwiperIt>
        <template v-else>
          <div class="partner-grid pc" >
            <img v-if="activeName == 'all'  || activeName == '3C industry'" src="@/assets/partner/图片3.png" alt="">
            <img v-if="activeName == 'all'  || activeName == '3C industry'" src="@/assets/partner/图片14.png" alt="">
            <img v-if="activeName == 'all'  || activeName == 'IT industry'" src="@/assets/partner/图片20.png" alt="">
            <img v-if="activeName == 'all'  || activeName == 'IT industry'" src="@/assets/partner/图片4.png" alt="">
            <img v-if="activeName == 'all'  || activeName == 'IT industry'" src="@/assets/partner/图片5.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'AUTOMOBILE Energy Storage'" src="@/assets/partner/图片6.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'Smart Home'" src="@/assets/partner/图片12.png" alt="">

            <img v-if="activeName == 'all'  || activeName == 'Large Household Appliances'" src="@/assets/partner/图片8.png" alt="">
            <img v-if="activeName == 'all'  || activeName == 'Large Household Appliances'" src="@/assets/partner/图片9.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'Smart Home'" src="@/assets/partner/图片10.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'Smart Home'" src="@/assets/partner/图片7.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'Smart Home'" src="@/assets/partner/图片13.png" alt="">

            <img v-if="activeName == 'all' || activeName == 'Short Distance Mobility'" src="@/assets/partner/图片15.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'AUTOMOBILE Energy Storage'"   src="@/assets/partner/图片18.png" alt="">
            <img v-if="activeName == 'all'  || activeName == '3C industry'" src="@/assets/partner/图片21.png" alt="">
            <img v-if="activeName == 'all' || activeName == '3C industry'" src="@/assets/partner/图片27.png" alt="">
            <img v-if="activeName == 'all'  || activeName == 'IT industry'" src="@/assets/partner/图片30.png" alt="">

            <img v-if="activeName == 'all'  || activeName == '3C industry'" src="@/assets/partner/图片31.png" alt="">
            <img v-if="activeName == 'all'  || activeName == '3C industry'" src="@/assets/partner/图片25.png" alt="">
            <img v-if="activeName == 'all' || activeName == '3C industry'"  src="@/assets/partner/图片24.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'IT industry'"  src="@/assets/partner/图片26.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'AUTOMOBILE Energy Storage'"  src="@/assets/partner/图片32.png" alt="">
          </div>
          <div class="patter-images mobile" >
            <img v-if="activeName == 'all'  || activeName == '3C industry'" src="@/assets/partner/图片3.png" alt="">
            <img v-if="activeName == 'all'  || activeName == '3C industry'" src="@/assets/partner/图片14.png" alt="">
            <img v-if="activeName == 'all'  || activeName == 'IT industry'" src="@/assets/partner/图片20.png" alt="">
            <img v-if="activeName == 'all'  || activeName == 'IT industry'" src="@/assets/partner/图片4.png" alt="">
            <img v-if="activeName == 'all'  || activeName == 'IT industry'" src="@/assets/partner/图片5.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'AUTOMOBILE Energy Storage'" src="@/assets/partner/图片6.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'Smart Home'" src="@/assets/partner/图片12.png" alt="">

            <img v-if="activeName == 'all'  || activeName == 'Large Household Appliances'" src="@/assets/partner/图片8.png" alt="">
            <img v-if="activeName == 'all'  || activeName == 'Large Household Appliances'" src="@/assets/partner/图片9.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'Smart Home'" src="@/assets/partner/图片10.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'Smart Home'" src="@/assets/partner/图片7.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'Smart Home'" src="@/assets/partner/图片13.png" alt="">

            <img v-if="activeName == 'all' || activeName == 'Short Distance Mobility'" src="@/assets/partner/图片15.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'AUTOMOBILE Energy Storage'"   src="@/assets/partner/图片18.png" alt="">
            <img v-if="activeName == 'all'  || activeName == '3C industry'" src="@/assets/partner/图片21.png" alt="">
            <img v-if="activeName == 'all' || activeName == '3C industry'" src="@/assets/partner/图片27.png" alt="">
            <img v-if="activeName == 'all'  || activeName == 'IT industry'" src="@/assets/partner/图片30.png" alt="">

            <img v-if="activeName == 'all'  || activeName == '3C industry'" src="@/assets/partner/图片31.png" alt="">
            <img v-if="activeName == 'all'  || activeName == '3C industry'" src="@/assets/partner/图片25.png" alt="">
            <img v-if="activeName == 'all' || activeName == '3C industry'"  src="@/assets/partner/图片24.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'IT industry'"  src="@/assets/partner/图片26.png" alt="">
            <img v-if="activeName == 'all' || activeName == 'AUTOMOBILE Energy Storage'"  src="@/assets/partner/图片32.png" alt="">
          </div>
        </template>
      </section>
    </div>
  </div>
</template>

<script>
import Products from "@/views/products.vue";
import IntroSwiper from "@/components/intro-swiper.vue";
import AboutSwiper from "@/components/about-swiper.vue";
import AboutSwiper3c from "@/components/about-swiper-3c.vue";
import AboutSwiperIt from "@/components/about-swiper-it.vue";


export default {
  name: "about",
  components: {IntroSwiper,AboutSwiper, Products,AboutSwiper3c,AboutSwiperIt},
  data() {
    return {
      activeName: 'all',
      partnerList: [
        {title: 'IT industry'},
        {title: '3C industry',},
        {title: 'Smart Home'},
        {title: 'Large Household Appliances'},
        {title: 'Short Distance Mobility'},
        {title: 'AUTOMOBILE Energy Storage'},
      ],
      industries: [
        {
          key: "it",
          products: ["server", "hard_disk", "driver", "projector", "printer", "gpu", "storage_device"],
          imgs: [
            require('@/assets/about/it/1.png'),
            require('@/assets/about/it/2.png'),
            require('@/assets/about/it/3.png'),
            require('@/assets/about/it/4.png'),
            require('@/assets/about/it/5.png'),
            require('@/assets/about/it/6.png'),
            require('@/assets/about/it/7.png'),
          ]
        },
        {
          key: "3c",
          products: ["computer", "phone", "tablet", "smart_watch", "earphones", "camera", "game_console"],
          imgs: [
            require('@/assets/about/3c/computer.png'),
            require('@/assets/about/3c/phone.png'),
            require('@/assets/about/3c/pac.png'),
            require('@/assets/about/3c/watch.png'),
            require('@/assets/about/3c/pods.png'),
            require('@/assets/about/3c/camera.png'),
            require('@/assets/about/3c/game.png'),
          ]
        },
        {
          key: "smart_home",
          products: ["cleaning_robot", "vacuum_cleaner", "humanoid_robot", "drone"],
          imgs: [
            require('@/assets/about/jiajv/1.png'),
            require('@/assets/about/jiajv/2.png'),
            require('@/assets/about/jiajv/3.png'),
            require('@/assets/about/jiajv/4.png'),
          ]
        },
        {
          key: "home_appliances",
          products: ["tv", "refrigerator", "air_conditioner", "washing_machine", "electric_fan"],
          imgs: [
            require('@/assets/about/jiadian/1.png'),
            require('@/assets/about/jiadian/2.png'),
            require('@/assets/about/jiadian/3.png'),
            require('@/assets/about/jiadian/4.png'),
            require('@/assets/about/jiadian/5.png'),
          ]
        },
        {
          key: "short_distance_travel",
          products: ["electric_vehicle", "scooter", "balance_vehicle", "bicycle"],
          imgs: [
            require('@/assets/about/duantu/1.png'),
            require('@/assets/about/duantu/2.png'),
            require('@/assets/about/duantu/3.png'),
            require('@/assets/about/duantu/4.png'),
          ]
        },
        {
          key: "car_energy_storage",
          products: ["car", "energy_storage_device"],
          imgs: [
            require('@/assets/about/car/1.png'),
            require('@/assets/about/car/2.png'),
          ]
        }
      ]
    }
  },
  computed: {
    values() {
        return  [
          {
            title: this.$t('about.valueTitle1'),
            img: require('@/assets/value/11.png')
          },
          {
            title: this.$t('about.valueTitle2'),
            img: require('@/assets/value/22.png')
          },
          {
            title: this.$t('about.valueTitle3'),
            img: require('@/assets/value/33.png')
          },
          {
            title: this.$t('about.valueTitle4'),
            img: require('@/assets/value/44.png')
          },
        ]
      },
    is_en() {
      return this.$t('language') === 'English'
    }
  }
}
</script>

<style lang="scss">
.el-tabs__item.is-active {
  color: #FF6B35!important;
}
.el-tabs__item:hover{
  color: #FF6B35!important;
}
.el-tabs__item{
  font-size: 18px !important;
  font-family: Inter, Tahoma, Verdana, sans-serif;
  font-weight: 500;
  padding: 0 20px;
  text-align: center;
}

.el-tabs__active-bar {
  background-color: #FF6B35!important;
}
.carditem0,.carditem3{
  background: #FF6B35 !important;
}
.carditem1,.carditem4{
  background: rgb(36, 75, 76) !important;
}
.carditem2,.carditem5{
  background: #FF6B35 !important;
}

.carditem0 h3{
  top: 105px !important;
}

.carditem1 h3,.carditem2 h3,.carditem3 h3{
  top: 90px !important;
}
.carditem4 h3{
  top: 77px !important;
}
.carditem5 h3{
  top: 95px !important;
}
.about-container {
  margin-top: 60px;
  background: #f2f3f5;
  position: relative;
  .building-image {
    width: 100%;
    height: 380px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    opacity: 0.5;
    background-image: url("@/assets/build.png");
    background-size: cover;
  }
  section {
    width: 1200px;
    margin: 0 auto;
    padding-top: 5rem;
  }
  .map {
    text-align: center;
    img {
      width: 100%;
      margin: 40px auto 0;
    }
  }
  h2 {
    text-align: center;
    //color: var(--primary-color);
    color: #000000;
    margin-bottom: 2rem;
    font-size: 40px;
    font-family: Inter, Tahoma, Verdana, sans-serif;
    font-weight: 500;
  }
  .brand-logo {
    font-size: 24px !important;
    color: var(--primary) !important;
    font-weight: 800;
    margin-right: 40px !important;
  }

  /* 公司简介模块 */
  .intro-section {
    position: absolute;
    top: 0 ;
    left: 0;
    width: 100%;
    .intro-content {
      position: absolute;
      top: 0 ;
      left: 0;
      width: 100%;
      height: 300px;
      padding: 0 30px;
      box-sizing: border-box;
        z-index: 10;
    }
    h2 {
      padding-top: 4.5rem;
      color: #FF6B35;
      font-weight: 500;
    }
    p {
      text-align: center;
      //line-height: 2;
      color: #ffffff;
      width: 1100px;
      margin: 0 auto;
      font-size: 1.5rem;
    }
  }
  .client-logos {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-top: 2rem;
  }

  /* 核心价值模块 */
  .value-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    width: 100%;
    gap: 15px;
    margin: 30px 0;
  }
  .value-card {
    background: white;
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 5px 20px rgba(0,0,0,0.08);
    text-align: center;
    h3 {
      padding-top: 15px;
    }
    p {
      padding-top: 10px;
      color: #999999;
      font-size: 14px;
    }
    .img {
      width: 220px;
      height: 220px;
      text-align: center;
      overflow: hidden;
      position: relative;
      margin: 0 auto;
    }
    &.item0 {
      img {
        width: 122%;
        height: 110%;
        position: absolute;
        top: -3%;
        left: -11%;
      }
    }
    &.item1 {
      img {
        width: 131%;
        height: 106%;
        position: absolute;
        top: -3%;
        left: -18%;
      }
    }
    &.item2 {
      img {
        width: 104%;
        height: 95%;
        position: absolute;
        top: -1%;
        left: -2%;
      }
    }
    &.item3 {
      img {
        width: 119%;
        height: 105%;
        position: absolute;
        top: -1%;
        left: -2%;
      }
    }
    img {
      //width: 100%;
      border: 0;
      object-fit: fill;
    }
  }
  &.en {
    .industry-grid {
      .industry-card {
        .industry-item {
          p {
            font-size: 11px;
            line-height: 1;
          }
          img {
            width: 15px;
            height: 15px;
          }
        }
      }
    }
  }
  /* 合作伙伴 */
  .industry-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    padding: 40px 0;
    text-align: center;
    /* 行业卡片样式 */
    .industry-card-wrapper {
      min-height: 220px;
      background: #ffffff;
      padding: 25px;
      border-radius: 5px;
      box-shadow: 0 2px 12px rgba(0,0,0,0.08);
      position: relative;
    }
    .industry-card {
      $circle-width1: 200px;
      $circle-width2: 2px;
      position: absolute;
      top: 10px;
      left: 70px;
      h3 {
        position: absolute;
        top: $circle-width1/2 + 5px;
        left: $circle-width1/2 + 20px;
        width: 100px;
        margin-left: -50px;
        text-align: center;
        color: #FF6B35;
      }
      .circle {
        width: $circle-width1;
        height: $circle-width1;
        background-color: #FF6B35;
        border-radius: 50%;
        position: absolute;
        top: 20px;
        left: 20px;
        &:before {
          content: '';
          top: $circle-width2;
          left: $circle-width2;
          position: absolute;
          width: $circle-width1 - $circle-width2 *2;
          height: $circle-width1 - $circle-width2*2;
          background-color: #ffffff;
          border-radius: 50%;
        }
      }
      $item-width: 60px;
      .industry-item {
        width: $item-width;
        height: $item-width;
        background: #ffffff;
        border: 1px solid #FF6B35;
        border-radius: $item-width/2;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        img {
          padding-top: 5px;
          width: 20px;
        }
        p {
          font-size: 13px;
          text-align: center;
          color: #000;
        }
      }
      &.item7 {
        .industry-item:nth-child(1){
          top: 0;
          left: 86px;
        }
        .industry-item:nth-child(2){
          top: 28px;
          left: 166px;
        }
        .industry-item:nth-child(3){
          top: 106px;
          left: 186px;
        }
        .industry-item:nth-child(4){
          top: 173px;
          left: 132px;
        }
        .industry-item:nth-child(5){
          top: 173px;
          left: 43px;
        }
        .industry-item:nth-child(6){
          top: 106px;
          left: -2px;
        }
        .industry-item:nth-child(7){
          top: 34px;
          left: 13px;
        }
      }
      &.item5 {
        .industry-item:nth-child(1){
          top: 0;
          left: 86px;
        }
        .industry-item:nth-child(2){
          top: 61px;
          left: 181px;
        }
        .industry-item:nth-child(3){
          top: 165px;
          left: 145px;
        }
        .industry-item:nth-child(4){
          top: 162px;
          left: 26px;
        }
        .industry-item:nth-child(5){
          top: 61px;
          left: -4px;
        }
      }
      &.item4 {
        .industry-item:nth-child(1){
          top: 0;
          left: 86px;
        }
        .industry-item:nth-child(2){
          top: 89px;
          left: 186px;
        }
        .industry-item:nth-child(3){
          top: 182px;
          left: 86px;
        }
        .industry-item:nth-child(4){
          top: 89px;
          left: -5px;
        }
      }
      &.item2 {
        .industry-item:nth-child(1){
          top: 89px;
          left: 186px;
        }
        .industry-item:nth-child(2){
          top: 89px;
          left: -5px;
        }
      }
    }
  }
  .partner {
    padding-bottom: 40px;
    .partner-grid {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 20px;
      padding-top: 40px;
      padding-bottom: 40px;
      img {
        width: 140px;
        height: 60px;
        background: #ffffff;
        box-shadow:  0 2px 10px rgba(0,0,0,0.1);
        padding: 10px 20px;
        object-fit: contain;
        border-radius: 5px;
      }
    }
  }
  .mobile {
    display: none;
  }
  @media (max-width: 768px) {
    .pc {
      display: none!important;
    }
    .partner .mobile {
      display: block;
    }
    .my-bullet {
      width: 50px;
    }

    .partner .patter-images {
      display: grid;
      padding: 10px;
      grid-template-columns: repeat(5, 1fr);
      img {
        width: 50px;
        height: 20px;
        display: block;
        margin: 0 auto 20px auto;
        padding: 10px 5px;
      }
    }
    .about-swiper-3c {
      .about-swiper-container {
        height: 400px;
      }
    }
    .about-swiper-it {
      .about-swiper-container {
        height: 400px;
      }
    }
    .intro-section p {
      width: 90%;
      font-size: 16px;
    }
    section {
      width: 100%;
      margin: 0 auto;
    }
    h2 {
      font-size: 1.5rem;
    }
    .value-grid {
      grid-template-columns: 1fr;
    }
    .industry-grid {
      grid-template-columns: repeat(1, 1fr);
    }
    .industry-grid .industry-card-wrapper {
      width: 324px;
      margin: 0 auto;
    }
    .partner.partner-grid {
      grid-template-columns: repeat(1, 1fr);
    }
  }
}
.coverage-map-wrapper {
  position: relative;
  height: 500px;
  background: #f8f9fa;
  border-radius: 12px;
  margin: 60px 0;
  .coverage-map{
    transform: scale(0.7, 0.7);
    transform-origin: 0 0;
  }
  img {
    position: absolute;
    z-index: 1;
  }
  .main {
    img {
      transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      transform:  translateY(0);
      z-index: 2;
      //box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    .country {
      transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      color: #ffffff;
      padding: 10px 20px;
      background: rgba(0,0,40,0.5);
      position: absolute;
      opacity: 0;
      z-index: 10;
      .country-name {
        font-size: 20px;
        font-weight: 700;
      }
      .country-state-name {
        font-size: 14px;
      }
    }
    &:hover {
      img {
        transform: translateY(-6px);
        transform-origin: center;
        //box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
        cursor: pointer;
      }
      .country {
        opacity: 1;
      }
    }
  }
  .p1 {
    top: 155px;
    left: 20px;
  }
  .p1-main {
    top: 320px;
    left: 100px;
  }
  .p5{
    top: 411px;
    left: 204px;
  }
  .p5-main {
    top: 451px;
    left: 268px;
  }
  .p2 {
    top: 20px;
    left: 118px;
  }
  .p3 {
    top: 20px;
    left: 380px;
  }
  .p4 {
    top: 20px;
    left: 580px;
  }
}
</style>
